<template lang="pug">
  .relationship-intervals
    table-row-interval(v-for="(pair, i) in tableDataPairs" :itemStart="pair[0]" :itemEnd="pair[1]" :key="i")
</template>
<script>
import { mapState, mapMutations, } from 'vuex'
import {
  SET_PARENT_TYPE,
  TOGGLE_CHALLENGE_RELATIONSHIP_DETAILS_MODAL,
} from '@/store/modules/record/modules/challenge/mutations-types'
import Challenge from '@/mixins/challenge'
import TableRowInterval from '@/components/record-details/table-components/TableRowInterval'

export default {
  components: { TableRowInterval, },
  mixins: [ Challenge, ],
  props: {
    type: {
      type: String,
      default: 'direct',
      validator: (value) => [ 'direct', 'ultimate', ].includes(value),
    },
    tableData: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {}
  },
  computed: {
    tableDataPairs () {
      let result = []
      for (let i = 0; i < this.tableData.length; i += 2) {
        result.push([ this.tableData[i], this.tableData[i + 1], ])
      }
      return result
    },

    ...mapState('record/challenge', [ 'fields', ]),
  },
  methods: {
    ...mapMutations('record/challenge', {
      toggleRelationshipDetailsModal: TOGGLE_CHALLENGE_RELATIONSHIP_DETAILS_MODAL,
      setRelationshipType: SET_PARENT_TYPE,
    }),
  },
}
</script>
<style lang="stylus">
  @import "../../../assets/styles/variables.styl"
</style>



// WEBPACK FOOTER //
// src/components/record-details/table-components/RelationshipIntervals.vue